import datepicker from './modules/datepicker'

document.addEventListener('DOMContentLoaded', () => {
  datepicker();
});